import LembarInstrumenR from './LembarInstrumenR';
import RincianKemajuan from './RincianKemajuan';
import KonfirmasiSelesai from './KonfirmasiSelesai';
import TransisiInstrumen from './TransisiInstrumen';
import InstrumenAll from './InstrumenAll';
import UnggahHasilSupervisi from './UnggahHasilSupervisi';

export const InstrumenConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/PerangkatKuesioner',
            component: InstrumenAll
        }
        ,{
            path     : '/LembarInstrumen',
            component: LembarInstrumenR
        }
        ,{
            path     : '/TransisiInstrumen',
            component: TransisiInstrumen
        }
        ,{
            path     : '/RincianKemajuan',
            component: RincianKemajuan
        }
        ,{
            path     : '/Sinkronisasi',
            component: KonfirmasiSelesai
        }
        ,{
            path     : '/unggah-hasil-supervisi',
            component: UnggahHasilSupervisi
        }
        // ,{
        //     path     : '/LembarInstrumen/{id}',
        //     component: LembarInstrumen
        // }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/Instrumen/InstrumenConfig.js